import { ADMIN_SESSION_EXPIRED } from "./utils/authSession";
import FoodReviews from "./pages/FoodReview/FoodReviews";
import SocialReports from "./pages/SocialReports/SocialReports";
import AppReleases from "./pages/Operations/AppReleases";
import DeviceUsage from "./pages/Operations/DeviceUsage";
import HealthReports from "./pages/Operations/HealthReports";
import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/layout/Layout";
import PrivateRoute from "./components/common/PrivateRoute";
import Login from "./pages/Auth/Login";
import Profile from "./pages/Auth/Profile";
import Dashboard from "./pages/Dashboard";
import NoticeList from "./pages/Notice/NoticeList";
import NoticeForm from "./pages/Notice/NoticeForm";
import FAQList from "./pages/FAQ/FAQList";
import FAQForm from "./pages/FAQ/FAQForm";
import MemberList from "./pages/Member/MemberList";
import Invite from "./pages/Invite";
import InviteTest from "./pages/InviteTest";
import { useAuthStore } from "./store/useStore";

function App() {
  const { checkAuth, logout } = useAuthStore();

  // 앱 시작 시 인증 상태 확인
  useEffect(() => {
    const expireSession = () => logout();
    window.addEventListener(ADMIN_SESSION_EXPIRED, expireSession);
    checkAuth();
    return () => window.removeEventListener(ADMIN_SESSION_EXPIRED, expireSession);
  }, [checkAuth, logout]);

  return (
    <Routes>
      {/* 공개 페이지들 */}
      <Route path="/login" element={<Login />} />
      <Route path="/invite" element={<Invite />} />
      <Route path="/invite-test" element={<InviteTest />} />

      {/* 보호된 라우트들 */}
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout>
              <Navigate to="/dashboard" replace />
            </Layout>
          </PrivateRoute>
        }
      />

      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </PrivateRoute>
        }
      />

      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <Layout>
              <Profile />
            </Layout>
          </PrivateRoute>
        }
      />

      <Route
        path="/notice"
        element={
          <PrivateRoute>
            <Layout>
              <NoticeList />
            </Layout>
          </PrivateRoute>
        }
      />

      <Route
        path="/notice/new"
        element={
          <PrivateRoute>
            <Layout>
              <NoticeForm />
            </Layout>
          </PrivateRoute>
        }
      />

      <Route
        path="/faq"
        element={
          <PrivateRoute>
            <Layout>
              <FAQList />
            </Layout>
          </PrivateRoute>
        }
      />

      <Route
        path="/faq/new"
        element={
          <PrivateRoute>
            <Layout>
              <FAQForm />
            </Layout>
          </PrivateRoute>
        }
      />

      <Route
        path="/member"
        element={
          <PrivateRoute>
            <Layout>
              <MemberList />
            </Layout>
          </PrivateRoute>
        }
      />

      <Route path="/food-reviews" element={<PrivateRoute><Layout><FoodReviews /></Layout></PrivateRoute>} />
      <Route path="/social-reports" element={<PrivateRoute><Layout><SocialReports /></Layout></PrivateRoute>} />
      <Route path="/app-releases" element={<PrivateRoute><Layout><AppReleases /></Layout></PrivateRoute>} />
      <Route path="/device-usage" element={<PrivateRoute><Layout><DeviceUsage /></Layout></PrivateRoute>} />
      <Route path="/health-reports" element={<PrivateRoute><Layout><HealthReports /></Layout></PrivateRoute>} />

      {/* 404 처리 */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;
